import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { InputRadio } from 'web-ui-components/lib/actions/radios';
import { default as content } from '../AddNewPayeeLandingPage/index.content';
import PayeeAccountDetails from './PayeeAccountDetails';
import InternationalPayeeAccountInfo from './InternationalPayeeAccountInfo';
import {
	validationPropsProtoTypes,
	ibanFieldPropTypes,
	internationalAccountNumberFieldPropTypes,
	bickOrSwiftFieldPropTypes,
	clearingCodeFieldPropTypes,
} from '../../states/addPayee/propTypes';
import withValidation from '../../../containers/withValidation';
import withBackEndError from '../../../containers/withBackEndError';

export const PayeeAccountTypeComponent = ({
	validationProps,
	iban,
	internationalAccountNumber,
	payeeAccountType = 'iban',
	bickOrSwift,
	clearingCode,
	noBicOrSwift,
	noBicOrSwiftChange,
	payeeAccountChange,
	errorMessage,
	isValid,
	showValidation,
}) => {
	const { payeeAccountLabel, payeeAccountDescription, IBANLabel, accountNumberLabel } = content;
	return (
		<Field>
			<FieldHeader name="payeeAccountType" titleText={payeeAccountLabel} description={payeeAccountDescription} />
			<InternationalPayeeAccountInfo />
			<FieldHeader name="payeeType" hasError={!isValid && showValidation} validationMessage={errorMessage} />
			<InputRadio.Default
				id="iban"
				isChecked={payeeAccountType === 'iban'}
				label={IBANLabel}
				name="payeeAccountType"
				onChange={payeeAccountChange}
			/>
			<InputRadio.Default
				id="accono"
				isChecked={payeeAccountType === 'accono'}
				label={accountNumberLabel}
				name="payeeAccountType"
				onChange={payeeAccountChange}
			/>
			<PayeeAccountDetails
				validationProps={validationProps}
				iban={iban}
				internationalAccountNumber={internationalAccountNumber}
				payeeAccountType={payeeAccountType}
				bickOrSwift={bickOrSwift}
				noBicOrSwift={noBicOrSwift}
				clearingCode={clearingCode}
				noBicOrSwiftChange={noBicOrSwiftChange}
			/>
		</Field>
	);
};

PayeeAccountTypeComponent.propTypes = {
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
	iban: PropTypes.shape(ibanFieldPropTypes).isRequired,
	internationalAccountNumber: PropTypes.shape(internationalAccountNumberFieldPropTypes).isRequired,
	payeeAccountType: PropTypes.string,
	bickOrSwift: PropTypes.shape(bickOrSwiftFieldPropTypes).isRequired,
	clearingCode: PropTypes.shape(clearingCodeFieldPropTypes).isRequired,
	noBicOrSwift: PropTypes.bool,
	noBicOrSwiftChange: PropTypes.func.isRequired,
	payeeAccountChange: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
};
export default PayeeAccountTypeComponent;

const countryRequiresIBANErrorMessage =
	"Sorry, it looks like the payee's bank is in a country that requires an IBAN. Please select IBAN and enter this to continue. If you don't have an IBAN, the payee should be able to get it for you.";

export const PayeeAccountTypeSelect = withValidation({
	validations: ['required'],
	key: 'payeeAccountType',
	message: countryRequiresIBANErrorMessage,
})(withBackEndError(PayeeAccountTypeComponent));
